package app.smartcoding.realrate.presentation.util

import app.smartcoding.realrate.domain.model.CreditRating
import app.smartcoding.realrate.domain.model.EvaluationResult

fun evaluateCreditDealUseCase(
    apr: Double,
    appreciation: Double,
    summaryExcellent: String,
    summaryGood: String,
    summaryFair: String,
    summaryPoor: String,
    summaryBad: String,
    detailsLowApr: String,
    detailsHighApr: String,
    detailsLowInterestCost: String,
    detailsHighInterestCost: String,
    detailsHighRateShortTerm: String,
    detailsGoodRateLongTerm: String,
): EvaluationResult {

    val aprScore = (100 - (apr - 5).coerceAtLeast(0.0) * 5).coerceIn(0.0, 100.0)
    val appreciationScore = (100 - (appreciation - 5).coerceAtLeast(0.0) * 1.8).coerceIn(0.0, 100.0)
    val finalScore = (aprScore * 0.6 + appreciationScore * 0.4)

    val rating = when {
        finalScore >= 80 -> CreditRating.EXCELLENT
        finalScore >= 60 -> CreditRating.GOOD
        finalScore >= 40 -> CreditRating.FAIR
        finalScore >= 20 -> CreditRating.POOR
        else -> CreditRating.BAD
    }

    val summary = when (rating) {
        CreditRating.EXCELLENT -> summaryExcellent
        CreditRating.GOOD -> summaryGood
        CreditRating.FAIR -> summaryFair
        CreditRating.POOR -> summaryPoor
        CreditRating.BAD -> summaryBad
    }

    val s = StringBuilder()

    when {
        apr < 10 -> s.append(detailsLowApr)
        apr > 20 -> s.append(detailsHighApr)
    }
    when {
        appreciation < 10 -> s.append(detailsLowInterestCost)
        appreciation > 50 -> s.append(detailsHighInterestCost)
    }
    when {
        apr > 15 && appreciation < 15 -> s.append(detailsHighRateShortTerm)
        apr < 10 && appreciation > 40 -> s.append(detailsGoodRateLongTerm)
    }

    return EvaluationResult(
        rating = rating,
        summary = summary,
        details = "${s.trim()}",
        score = finalScore
    )
}
